import { Rating } from '@/models/Rating';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { RatingRadio } from './RatingRadio';

type FeedbackRatingProps = {
    name: string;
    value: Rating;
    onChange: Dispatch<SetStateAction<Rating>>;
    playButtonAudio: () => void;
};

export const FeedbackRating = (props: FeedbackRatingProps) => {
    const { t } = useTranslation();
    const { name, value, onChange, playButtonAudio } = props;
    const groupKey = `feedback-radio-${name}`;
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const v = Number(event.target.value);
        onChange(v);
        playButtonAudio();
    };
    return (
        <FormControl className="feedback-rating">
            <Grid
                container
                key={groupKey}
                className="feedback-rating-container"
            >
                <Grid item container className="feedback-rating-title">
                    <FormLabel>{t(name)}</FormLabel>
                    {/* {value >= 0 && (
                        <FormLabel>{t('feedback.' + Rating[value])}</FormLabel>
                    )} */}
                </Grid>
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                >
                    {Object.values(Rating)
                        .filter(value => typeof value === 'number')
                        .map(r => Number(r))
                        .filter(r => r > -1)
                        .sort((a, b) => b - a)
                        .map(r => (
                            <RatingRadio
                                key={`${groupKey}-${r}`}
                                value={r}
                                name={name}
                                checked={value === r}
                                inputProps={{ 'aria-label': Rating[r] }}
                                onChange={handleChange}
                            />
                        ))}
                </Grid>
            </Grid>
        </FormControl>
    );
};
